import React from 'react';
import { toast as rctToast } from "react-toastify";

export const toast = (type: "SUCCESS" | "ERROR", message: string, options?: { autoClose?: number }) => {
	switch (type) {
		case "SUCCESS":
			rctToast.success(message, {
				autoClose: options?.autoClose ?? 2000,
				position: "bottom-right"
			});
			break;
		case "ERROR":
			rctToast.error(message || "Something went wrong. Please try again in some time", {
				autoClose: options?.autoClose ?? 2000,
				position: "bottom-right"
			});
	}
};

let isSessionExpiring = false;

/** Success toast with an inline action button, e.g. "Deleted Sofa — Undo". The action runs once, then the toast closes. */
export const toastWithAction = (
	message: string,
	actionLabel: string,
	onAction: () => void,
	options?: { autoClose?: number }
) => {
	if (isSessionExpiring) return;
	const id = rctToast.success(
		({ closeToast }: { closeToast?: () => void }) => (
			<div className="toast-structured flex items-center justify-between gap-3">
				<span className="toast-message">{message}</span>
				<button
					type="button"
					className="shrink-0 rounded-md px-2 py-1 text-sm font-semibold underline"
					onClick={event => {
						event.stopPropagation();
						onAction();
						closeToast?.();
						rctToast.dismiss(id);
					}}
				>
					{actionLabel}
				</button>
			</div>
		),
		{
			autoClose: options?.autoClose ?? 5000,
			position: 'top-right',
			closeOnClick: false,
			className: 'toast-top-right max-w-[50vw]'
		}
	);
	return id;
};
